import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const MergeObligation = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-zdruzi-obveznosti.png" xPos="20%" yPos="13%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Enostavno združite obveznosti v en kredit!</h1>
                    <p className="text-left">
                      Več obveznosti pomeni več papirologije, rokov plačila in nepotrebnega stresa.                      
                    </p>
                    <p className="text-left red-text">
                      <b>Z združitvijo vseh obveznosti v en Addiko kredit lahko pridobite večjo preglednost in nižjo mesečno obremenitev – in dodatno gotovino!</b>
                    </p>
                    <p className="text-left">
                      Uredite enostavno, hitro in brez visokih stroškov. <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b> 
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}